export default __webpack_public_path__ + "static/media/BM.18192f19.svg";